module.exports = __webpack_public_path__ + "static/media/blog5.affde1bf.jpg";